// extracted by mini-css-extract-plugin
export default {"article":"BackgroundModel_article__3N7ef","header":"BackgroundModel_header__-RAT+"};